import type { PageSplit } from "../context";

/** Lab view config persists the split as a single numeric `layout` percentage; these map to/from it. */
export function pageSplitToLayout(pageSplit: PageSplit): number {
	if (pageSplit.kind === "pixels") {
		// TODO: pixel split values written raw as layout; on next load they snap to nearest ratio
		return pageSplit.width;
	}
	switch (pageSplit.width) {
		case "1/3":
			return 33;
		case "1/2":
			return 50;
		case "2/3":
			return 67;
	}
}

export function layoutToPageSplit(layout: number | undefined): PageSplit {
	if (layout == null) {
		return { kind: "ratio", width: "1/2" };
	}
	if (layout < 42) {
		return { kind: "ratio", width: "1/3" };
	}
	if (layout < 59) {
		return { kind: "ratio", width: "1/2" };
	}
	return { kind: "ratio", width: "2/3" };
}

export function pageSplitToCssWidth(pageSplit: PageSplit): string {
	if (pageSplit.kind === "pixels") {
		return `${pageSplit.width}px`;
	}
	switch (pageSplit.width) {
		case "1/3":
			return "33%";
		case "1/2":
			return "50%";
		case "2/3":
			return "67%";
	}
}
